import { useInsuranceStore } from "@/store/insurance";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";

const useInsuranceEffect = () => {
    const insuranceStore = useInsuranceStore();

	const filterPassengers = () => {
        const passengers = insuranceStore.getPassengers.filter(p => p.insuranceType === insuranceStore.getType);
        insuranceStore.setPassengers(passengers);
    }

	const insuranceType = computed(() => insuranceStore.getType);

    const unsubscribe = ref<any[]>([]);
    onMounted(() => {
        unsubscribe.value.push(watch(insuranceType, () => {
            filterPassengers();
        }));
    });

    onBeforeUnmount(() => {
        unsubscribe.value.forEach(v => v());
    })
}

export default useInsuranceEffect;